import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from "@material-ui/pickers";

import LocalizedUtils, { moment } from "../../../utils/LocalizedUtils";

import { setFilter, requestConferences, resetFilter } from "../../../actions/passcodeManager";

const useStyles = makeStyles(theme => ({
  filterContainer: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  buttonContainer: {
    marginTop: theme.spacing(1),
    width: "100%",
    display: "inline-flex",
  },
  spaceButtons: {
    flex: "1",
    width: "10px",
  },
  lineExpander: {
    flexGrow: 1,
  },
  lineBreak: {
    width: "100%",
  },
  createdText: {
    padding: theme.spacing(2, 1, 1, 1),
    fontSize: 15,
  },
  createdTextBinding: {
    padding: theme.spacing(2, 1, 1, 1),
    fontSize: 15,
  },
}));

export const PMConferencesFilterComponent = ({
  filter,
  requestPMConferncesInProgress,
  translate,
  setFilterFn,
  clearFilterFn,
  requestConferencesFn,
}) => {
  const classes = useStyles();

  const handleTextChange = name => event => {
    setFilterFn({ ...filter, [name]: event.target.value });
  };

  const handleDateChange = (name, date) => {
    setFilterFn({ ...filter, [name]: moment.utc(date) });
  };

  return (
    <div className={classes.filterContainer}>
      <Typography variant="subtitle1" id="filterTitle">
        Filter
      </Typography>
      <div className={classes.lineBreak} />
      <TextField
        id="conferences-confId"
        label={translate.conferenceId}
        className={classes.textField + " " + classes.lineExpander}
        value={filter.confId}
        onChange={handleTextChange("confId")}
      />
      <TextField
        id="conferences-hostPasscode"
        label={translate.hostPasscode}
        className={classes.textField + " " + classes.lineExpander}
        value={filter.hostPasscode}
        onChange={handleTextChange("hostPasscode", true)}
      />
      <TextField
        id="conferences-guestPasscode"
        label={translate.guestPasscode}
        className={classes.textField + " " + classes.lineExpander}
        value={filter.guestPasscode}
        onChange={handleTextChange("guestPasscode", true)}
      />
      <div className={classes.lineBreak} />
      <TextField
        id="conferences-eMail"
        label={translate.ownerEmail}
        className={classes.textField + " " + classes.lineExpander}
        value={filter.eMail}
        onChange={handleTextChange("eMail")}
      />
      <TextField
        id="conferences-comment"
        label={translate.comment}
        className={classes.textField + " " + classes.lineExpander}
        value={filter.comment}
        onChange={handleTextChange("comment")}
      />
      <TextField
        id="conferences-contractNumber"
        label={translate.contractNo}
        className={classes.textField + " " + classes.lineExpander}
        value={filter.contractNumber}
        onChange={handleTextChange("contractNumber")}
      />
      <div className={classes.lineBreak} />
      <div className={classes.createdText}>{translate.creationDate}</div>
      <MuiPickersUtilsProvider libInstance={moment} utils={LocalizedUtils}>
        <KeyboardDateTimePicker
          id="conferences-creation-date-from"
          label={translate.from}
          className={classes.textField + " " + classes.lineExpander}
          ampm={false}
          format="DD.MM.YYYY HH:mm:ss"
          value={filter.creationDateFrom}
          onChange={date => handleDateChange("creationDateFrom", date)}
        />
      </MuiPickersUtilsProvider>
      <div className={classes.createdTextBinding}>-</div>
      <MuiPickersUtilsProvider libInstance={moment} utils={LocalizedUtils}>
        <KeyboardDateTimePicker
          id="conferences-creation-date-to"
          label={translate.to}
          className={classes.textField + " " + classes.lineExpander}
          ampm={false}
          format="DD.MM.YYYY HH:mm:ss"
          value={filter.creationDateTo}
          onChange={date => handleDateChange("creationDateTo", date)}
        />
      </MuiPickersUtilsProvider>
      <div className={classes.buttonContainer}>
        <div className={classes.spaceButtons} />
        <Button size="small" onClick={() => clearFilterFn()}>
          {translate.clearButtonFilter}
        </Button>
        <Button
          disabled={requestPMConferncesInProgress}
          variant="contained"
          size="small"
          color="primary"
          onClick={() => {
            setFilterFn({ ...filter, page: 0 });
            requestConferencesFn({ ...filter, page: 0 });
          }}
        >
          {translate.searchButtonFilter}
        </Button>
      </div>
    </div>
  );
};

PMConferencesFilterComponent.propTypes = {
  filter: PropTypes.object.isRequired,
  setFilterFn: PropTypes.func.isRequired,
  clearFilterFn: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
  requestConferencesFn: PropTypes.func.isRequired,
  requestPMConferncesInProgress: PropTypes.bool.isRequired,
};

const mapDispatchToProps = dispatch => ({
  setFilterFn: filter => dispatch(setFilter(filter)),
  requestConferencesFn: filter => dispatch(requestConferences(filter)),
  clearFilterFn: () => dispatch(resetFilter()),
});

const mapStateToProps = state => ({
  filter: state.passcodeManager.filter,
  requestPMConferncesInProgress: state.passcodeManager.requestPMConferncesInProgress,
  translate: state.ui.translate,
});

const PMConferencesFilter = connect(
  mapStateToProps,
  mapDispatchToProps
)(PMConferencesFilterComponent);

export default PMConferencesFilter;
